<template>
  <div class="taahodat-riz-modal" dir="rtl">
    <div class="taahodat-riz-modal__header">
      <div class="taahodat-riz-modal__intro">
        <div class="taahodat-riz-modal__intro-text">
          <h6 class="taahodat-riz-modal__title">
            <i class="fas fa-list-ol" aria-hidden="true"></i>
            برنامه اقساط
          </h6>
          <p class="taahodat-riz-modal__subtitle">
            اقساط مورد نظر را انتخاب کنید و سپس تایید کنید.
          </p>
        </div>
        <button
          type="button"
          class="taahodat-riz-modal__close close"
          data-dismiss="modal"
          aria-label="بستن"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div v-if="sumMabRiz > 0" class="taahodat-riz-modal__summary">
        <span>جمع اقساط انتخاب‌شده</span>
        <strong>{{ $Comma3ragham(sumMabRiz + Math.floor(sumMabJarime)) }}</strong>
      </div>
    </div>

    <div class="taahodat-riz-modal__table-wrap">
      <table class="table table-hover taahodat-riz-modal__table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">تاریخ قسط</th>
            <th scope="col">مبلغ قسط</th>
            <th scope="col">مبلغ جریمه</th>
            <th scope="col">تاریخ سند</th>
            <th scope="col">شماره سند</th>
            <th scope="col">عملیات</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(itemRiz, key) in ListTaahodatRiz"
            :key="key"
            :class="{
              'taahodat-riz-modal__row--selected': itemRiz.select == true,
            }"
          >
            <th scope="row">{{ key + 1 }}</th>
            <td>{{ itemRiz.tarixGhest }}</td>
            <td>{{ $Comma3ragham(itemRiz.mablaghGhest) }}</td>
            <td>{{ $Comma3ragham(itemRiz.mabJarime) }}</td>
            <td>
              {{
                itemRiz.tarixSanad == null ? "سند ثبت نشده" : itemRiz.tarixSanad
              }}
            </td>
            <td>
              {{
                itemRiz.shomareSanad == null
                  ? "سند ثبت نشده"
                  : itemRiz.shomareSanad
              }}
            </td>
            <td v-if="itemRiz.shomareSanad == null">
              <button
                type="button"
                class="taahodat-riz-chip"
                :class="
                  itemRiz.select == true
                    ? 'taahodat-riz-chip--remove'
                    : 'taahodat-riz-chip--select'
                "
                @click="SelectRiz(itemRiz)"
              >
                <i
                  :class="
                    itemRiz.select == true ? 'fa fa-times' : 'fa fa-check'
                  "
                  aria-hidden="true"
                ></i>
                {{ itemRiz.select == true ? "حذف" : "انتخاب" }}
              </button>
            </td>
            <td v-else class="taahodat-riz-modal__posted">سند شده</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="taahodat-riz-modal__footer">
      <button
        v-if="ListTaahodatRiz != null && ListTaahodatRiz != []"
        type="button"
        class="btn btn-success taahodat-riz-modal__confirm"
        :disabled="sumMabRiz <= 0 ? true : false"
        data-dismiss="modal"
        @click="SetMablagh"
      >
        <span v-if="sumMabRiz > 0">تایید اقساط</span>
        <span v-else>لطفا یک یا چند قسط را انتخاب نمایید</span>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ListTaahodatRiz: null,
      sumMabRiz: 0,
      sumMabJarime: 0,
    };
  },
  props: ["taahodatId"],
  methods: {
    GetTaahodatRiz(taahodatId) {
      let DataAxios_Taahodatriz = {
        ArryfildValue: "",
        Method: "Post",
        Action: "LoanCardex",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("taahodatId", taahodatId);
      formData.append(
        "shobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId
      );
      DataAxios_Taahodatriz.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Taahodatriz).then((data) => {
        if (typeof(data) == "string") {
          data = JSON.parse(data)
          for (let index = 0; index < data.length; index++) {
          var element = data[index];
          for (var key in element) {
            var temp = JSON.parse(JSON.stringify(key)) 
            var newkey =temp.charAt(0).toLowerCase() + temp.slice(1);
            element[ newkey ] = element[key];
            element[ 'row' ] = index +1
            delete element[key];
          }

          }
          this.ListTaahodatRiz = data

        }
        else if (data.status && data.status=='Ok') {
          this.ListTaahodatRiz = data.result
        }
        else{
         
          var list = [];
            data.forEach((element) => {
            element.select = false;
            list.push(element);
          });
          // this.ListTaahodatRiz=data.result
          this.ListTaahodatRiz = list;
        
        }

      });
    },
    SelectRiz(itemRiz) {
      if (itemRiz.shomareSanad == null || itemRiz.tarixSanad == null) {
        itemRiz.select = !itemRiz.select;
        let ItemMab = itemRiz.mablaghGhest;
        
        let ItemMabJarime = itemRiz.mabJarime;
        let ItemMabBakhshesh = itemRiz.mabBakhshesh==undefined ? 0 : itemRiz.mabBakhshesh;
        if (itemRiz.select) {
          itemRiz['mabBakhshesh']= itemRiz.mabBakhshesh==undefined ? 0 : itemRiz.mabBakhshesh;
          this.CountSelectedTaahodatRizMovaghat += 1;
          this.sumMabRiz = this.sumMabRiz + ItemMab;
          this.sumMabJarime = (this.sumMabJarime + (ItemMabJarime-ItemMabBakhshesh));

        } else {
          if (this.CountSelectedTaahodatRiz > 0) {
            this.CountSelectedTaahodatRizMovaghat -= 1;
          }
          this.sumMabRiz = this.sumMabRiz - ItemMab;
          this.sumMabJarime = (this.sumMabJarime - (ItemMabJarime-ItemMabBakhshesh));
        }
        //  console.log(this.sumMabRiz);
      } else {
        this.$mySweetDefaultTost(
          "عدم انتخاب",
          "قسط انتخابی شما ثبت سند شده ، لطفا قسط دیگیری را انتخاب کنید",
          "warning",
          3000
        );
      }
    },
    SetMablagh() {
      this.SaveTaahodatRiz()
      // console.log(this.sumMabRiz);
      // console.log(this.sumMabJarime);
      // console.log(Math.floor(this.sumMabJarime));
      // console.log(this.sumMabRiz+Math.floor(this.sumMabJarime));
      this.$emit("SumMablagh", this.sumMabRiz+Math.floor(this.sumMabJarime));
      this.$emit("SumMablaghJarime", this.sumMabJarime);
      
    },
    SaveTaahodatRiz(){
      let list=[]
      for (let index = 0; index < this.ListTaahodatRiz.length; index++) {
        if (this.ListTaahodatRiz[index].select== true) {
          list.push(this.ListTaahodatRiz[index]);
        }
      }
      this.$emit("ListTaahodatRiz", list);
    },
  },
  mounted() {
    this.sumMabJarime=0;
    // this.GetTaahodatRiz(this.taahodatId);
    this.GetTaahodatRiz(this.taahodatId);
  },
};
</script>
<style scoped>
.taahodat-riz-modal {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: min(calc(100dvh - 1.5rem), calc(100vh - 1.5rem));
  background: #fff;
  text-align: right;
}

.taahodat-riz-modal__header {
  flex-shrink: 0;
  padding: 0.85rem 1rem 0.75rem;
  border-bottom: 1px solid #e8eef2;
}

.taahodat-riz-modal__intro {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.65rem;
}

.taahodat-riz-modal__title {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0 0 0.35rem;
  color: #29345f;
  font-size: 15px !important;
  font-weight: 800;
}

.taahodat-riz-modal__title i {
  color: #56508d;
}

.taahodat-riz-modal__subtitle {
  margin: 0;
  color: #6b7b8e;
  font-size: 13px;
  line-height: 1.7;
}

.taahodat-riz-modal__close {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin: 0;
  padding: 0;
  float: none;
  color: #2a3f54 !important;
  font-size: 1.35rem;
  line-height: 1;
  text-shadow: none;
  border-radius: 8px;
  background: rgba(42, 63, 84, 0.08);
  opacity: 1;
}

.taahodat-riz-modal__close:hover {
  background: rgba(42, 63, 84, 0.14);
}

.taahodat-riz-modal__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding: 0.65rem 0.8rem;
  color: #56508d;
  font-size: 13px;
  font-weight: 700;
  border-radius: 12px;
  background: linear-gradient(110deg, #edf7fb, #f4eef8);
}

.taahodat-riz-modal__summary strong {
  color: #29345f;
  font-size: 14px;
}

.taahodat-riz-modal__table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 0 0.35rem;
}

.taahodat-riz-modal__table {
  margin: 0;
  font-size: 13px;
}

.taahodat-riz-modal__table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  color: #29345f;
  font-weight: 800;
  text-align: center;
  white-space: nowrap;
  background: #f8fafc;
  border-color: #e8eef2;
}

.taahodat-riz-modal__table tbody td,
.taahodat-riz-modal__table tbody th {
  vertical-align: middle;
  text-align: center;
  color: #13243a;
  border-color: #e8eef2;
}

.taahodat-riz-modal__row--selected {
  background: #edf7fb !important;
}

.taahodat-riz-modal__posted {
  color: #6b7b8e;
  font-weight: 700;
}

.taahodat-riz-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 32px;
  min-width: 5.5rem;
  padding: 0.25rem 0.7rem;
  border: 1px solid;
  border-radius: 10px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.taahodat-riz-chip--select {
  color: #2f7a1f;
  border-color: #b7dfb0;
  background: #eef8ec;
}

.taahodat-riz-chip--remove {
  color: #b44f46;
  border-color: #f0d4d1;
  background: #fcefed;
}

.taahodat-riz-modal__footer {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  padding: 0.85rem 1rem;
  border-top: 1px solid #e8eef2;
}

.taahodat-riz-modal__confirm {
  min-width: 10rem;
  min-height: 40px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 700;
}

.taahodat-riz-modal__confirm:disabled {
  opacity: 0.65;
}
</style>
<style>
#Modal-Success:has(.taahodat-riz-modal) .modal-dialog {
  margin: 1.25rem auto;
  max-width: min(860px, calc(100vw - 2rem));
  width: calc(100% - 2rem);
}

#Modal-Success:has(.taahodat-riz-modal) .modal-content {
  overflow: hidden;
  max-height: min(calc(100dvh - 1.5rem), calc(100vh - 1.5rem));
  border: none;
  border-radius: 18px;
  background: #fff !important;
  box-shadow: 0 8px 32px rgba(42, 63, 84, 0.18);
}

#Modal-Success:has(.taahodat-riz-modal) .modal-header {
  display: none !important;
}

#Modal-Success:has(.taahodat-riz-modal) .modal-body {
  max-height: min(calc(100dvh - 1.5rem), calc(100vh - 1.5rem));
  padding: 0;
  overflow: hidden;
}

@media (max-width: 767px) {
  #Modal-Success:has(.taahodat-riz-modal) .modal-dialog {
    margin: 0.75rem auto;
    width: calc(100% - 1.25rem);
    max-width: calc(100% - 1.25rem);
  }
}
</style>
